import { useState, useEffect } from 'react';
import { ModalHeader, ModalBody, Modal } from 'design-react-kit';
import { SchedaPersonaSimpleView } from 'uniba-volto-persone/components';

const SchedaPersonaModalView = ({ props, startsOpen = true, setOpen }) => {
    const [isOpen, setIsOpen] = useState(startsOpen);

    useEffect(() => {
        setIsOpen(startsOpen);
    }, [startsOpen]);

    function handleClose() {
        setIsOpen(false);
        setOpen(false);
    }

    return (
        <Modal
            isOpen={isOpen}
            toggle={handleClose}
            className="scheda-modal-dialog"
            contentClassName="scheda-modal-content"
        >
            <ModalHeader className="p-0 scheda-persona-modal-header z-1" toggle={handleClose} />
            <ModalBody className={`p-4 scheda-persona-modal-body ${props?.review_state}`}>
                <SchedaPersonaSimpleView props={props} onClose={handleClose} />
            </ModalBody>
        </Modal>
    );
};

export default SchedaPersonaModalView;
